module.exports = __webpack_public_path__ + "static/media/Pro.1ad93ee5.png";